import React from 'react';
import { PremiumButton } from './ui/PremiumButton';

interface QuizRecommendationCardProps {
  title: string;
  description: string;
  ctaLabel: string;
  onSelect: () => void;
}

const QuizRecommendationCardComponent: React.FC<QuizRecommendationCardProps> = ({
  title,
  description,
  ctaLabel,
  onSelect,
}) => (
  <article
    className="rounded-[20px] border border-white/[0.08] bg-black/40 p-5 backdrop-blur-xl"
    style={{
      background: 'linear-gradient(145deg, rgba(19,19,21,0.82) 0%, rgba(10,10,12,0.76) 100%)',
      boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.07), 0 12px 28px rgba(0,0,0,0.28)',
    }}
  >
    <h3 className="text-[20px] font-semibold leading-tight tracking-tight text-white">
      {title}
    </h3>
    <p className="mt-3 text-[14px] leading-[1.55] text-white/65">
      {description}
    </p>
    <PremiumButton fullWidth variant="primary" className="mt-5" onClick={onSelect}>
      {ctaLabel}
    </PremiumButton>
  </article>
);

export const QuizRecommendationCard = React.memo(QuizRecommendationCardComponent);
